import { oc } from '@orpc/contract';
import { depreciationPresetSchema, updateDepreciationPresetInputSchema } from '../schemas/templates.schemas.js';
/** ADMIN. Edits the workspace's copy of a starter preset; no template changes until it is applied. */
export const updateDepreciationPresetContract = oc
    .route({
    method: 'POST',
    path: '/templates/presets/{key}',
    tags: ['Templates'],
    summary: 'Edit a starter preset',
})
    .input(updateDepreciationPresetInputSchema)
    .output(depreciationPresetSchema);
//# sourceMappingURL=update-depreciation-preset.contract.js.map